let uniqueId = null;

window.addEventListener('DOMContentLoaded', function() {

    uniqueId = localStorage.getItem('carved_unique_id');
  
  if (!uniqueId) {
    // If not in localStorage, get new fingerprint
    ThumbmarkJS.getFingerprint().then(fp => {
        uniqueId = fp;
      localStorage.setItem('carved_unique_id', fp);
    });
  } 
});

function carvedLog(event_type, event_action, gen_id) {
  fetch('https://3uy37mh32nszefuwqzdvpk7suq0tihok.lambda-url.us-east-1.on.aws/', { 
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      event_type,
      event_action, 
      gen_id,
      uid: uniqueId
    })
  }).catch(() => {
  });
}

document.addEventListener('click', function(e) {
  const el = e.target.closest('.carved-log');
  if (el) {
    carvedLog(
      el.dataset.event_type,
      el.dataset.event_action,
      el.dataset.gen_id
    );
  }
});